import { ToolbarStorageToUiConverter } from './ToolbarStorageToUiConverter';
import { _DevToolBarForm } from './DevToolbarForm';

const DevToolBarForm = new _DevToolBarForm();

export function useDevToolbar() {
  const reset = () => DevToolBarForm.reset(ToolbarStorageToUiConverter.getInitStates());

  DevToolBarForm.validate();

  const submit = () => ToolbarStorageToUiConverter.patch(DevToolBarForm.getDTO());

  return {
    formData: DevToolBarForm.formData,
    reset,
    submit,
    isApiSwitched: computed(() => DevToolBarForm.isAPISwitched),
  };
}
